import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=7ab8398b"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports